import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SidebarLayout from './components/SidebarLayout';
import FullCalendarPerEmployee from './components/FullCalendarPerEmployee';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Customers from './pages/Customers';
import Services from './pages/Services';
import AuthPage from './pages/Auth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// ✅ User Context
import { UserProvider } from './context/UserContext';

// ✅ Private Route wrapper
import PrivateRoute from './auth/PrivateRoute';

function App() {
  return (
    <UserProvider>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        closeOnClick
        pauseOnHover
        theme="colored"
        style={{ zIndex: 99999 }}
      />

      <Router>
        <Routes>
          {/* Δημόσια σελίδα login/register */}
          <Route path="/auth" element={<AuthPage />} />

          {/* Προστατευμένες σελίδες μέσα στο Sidebar */}
          <Route path="/" element={<SidebarLayout />}>
            <Route index element={<Navigate to="/calendar" replace />} />

            <Route
              path="calendar"
              element={
                <PrivateRoute>
                  <FullCalendarPerEmployee />
                </PrivateRoute>
              }
            />
            <Route
              path="dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="employees"
              element={
                <PrivateRoute>
                  <Employees />
                </PrivateRoute>
              }
            />
            <Route
              path="customers"
              element={
                <PrivateRoute>
                  <Customers />
                </PrivateRoute>
              }
            />
            <Route
              path="services"
              element={
                <PrivateRoute>
                  <Services />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
